import { NgModule } from '@angular/core';
import { SharedModule } from './../sharedModule/sharedModule.module';
import { XInformationBarComponent } from './x-information-bar.component';

@NgModule({
  imports: [SharedModule],
  declarations: [XInformationBarComponent],
  exports: [XInformationBarComponent],
})
export class XInformationBarModule {}
